import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from "@angular/core";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import {
  SingleSelectQuestion,
  SingleSelectQuestionAnswer,
} from "src/app/models";

@Component({
  selector: "app-single-select-question",
  templateUrl: "single-select-question.component.html",
  styleUrls: ["./single-select-question.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SingleSelectQuestionComponent {
  @HostBinding("class") class = "app-single-select-question";

  @Input() set question(question: SingleSelectQuestion) {
    this.myQuestion = question;

    this.answers.clear();
    this.answers.reset();
    question?.answers?.forEach((a) =>
      this.answers.push(this.getFormGroupFromAnswer(a))
    );
  }

  get question(): SingleSelectQuestion {
    return {
      ...this.myQuestion,
      answers: this.answers.value,
    };
  }

  get valid(): boolean {
    return this.answers.valid;
  }

  get dirty(): boolean {
    return this.answers.dirty;
  }

  answers = new FormArray([]);

  private myQuestion: SingleSelectQuestion;

  getIsCorrectTitle(isCorrect: boolean): string {
    return isCorrect ? "Correct" : "Incorrect";
  }

  setAsCorrect(correctControl: FormControl): void {
    this.answers.controls.forEach((c: FormGroup) =>
      c.controls.isCorrect.setValue(c.controls.isCorrect === correctControl)
    );
    this.answers.markAsDirty();
  }

  addAnswer(): void {
    this.answers.push(
      new FormGroup({
        text: new FormControl("", Validators.required),
        isCorrect: new FormControl(false),
      })
    );
    this.answers.markAsDirty();
  }

  removeAnswerAtIndex(index: number): void {
    this.answers.removeAt(index);
    this.answers.markAsDirty();
  }

  getFormGroupFromAnswer(answer: SingleSelectQuestionAnswer): FormGroup {
    return new FormGroup({
      text: new FormControl(answer.text, Validators.required),
      isCorrect: new FormControl(answer.isCorrect || false),
    });
  }
}
